mtl.alloy.factory.odometer = (function($) {
    'use strict';

    var BLUR_THRESHOLD = 1;

    var DURATION_BASE       = 240;
    var DURATION_PER_DIGIT  = 120;

    var DIGIT_ELEMENT = $.parseHTML(
        '<span class="odometer__digit"><i><b></b></i></span>'
    )[0];

    var SEPARATOR_ELEMENT = $.parseHTML(
        '<span class="odometer__sep"></span>'
    )[0];


    /**
     * Return the odometer factory function.
     */
    return function(element, options) {

        var $element = $(element).first();
        element = $element[0];

        var $value = $element.find('.value');

        var currentValue = -1;

        var digitColumns = [];
        var separatorColumns = [];

        var tweener = util.arrayTweener([]);


        /**
         * Get digits for the given value.
         */
        function getDigits(_value) {

            _value = _value | 0;

            return (_value + '').split('').reverse().map(function(d) {
                return d | 0;
            });

        }


        /**
         * Add a digit column.
         */
        function addDigitColumn(_instant) {

            var $digit = $(DIGIT_ELEMENT).clone();

            if (_instant !== true) {
                $digit
                    .addClass('is-new')
                    .delay(50)
                    .queue(function(next) {
                        $digit.removeClass('is-new');
                        next();
                    })
                ;
            }

            digitColumns.push(
                $digit.prependTo(element)
            );

        }


        /**
         * Add a separator column.
         */
        function addSeparatorColumn(_instant) {

            var $separator = $(SEPARATOR_ELEMENT).clone();

            if (_instant !== true) {
                $separator
                    .addClass('is-new')
                    .delay(50)
                    .queue(function(next) {
                        $separator.removeClass('is-new');
                        next();
                    })
                ;
            }

            separatorColumns.push(
                $separator.prependTo(element)
            );

        }


        /**
         * Add a column for each digit.
         */
        function addColumns(_value, _instant) {

            var _digits = getDigits(_value);

            for (var i = 0, ix = _digits.length; i < ix; i++) {

                var si = (Math.floor(i / 3) - 1) | 0;
                if (si > -1 && separatorColumns[si] == null) {
                    addSeparatorColumn(_instant);
                }

                if (digitColumns[i] == null) {
                    addDigitColumn(_instant);
                }

            }

        }


        /**
         * Get the vertical offset of each digit.
         */
        function getDigitOffsets(_value) {

            _value = _value | 0;

            var _digits = getDigits(_value);

            return _digits.map(function(_digit, i) {
                return (_value / Math.pow(10, i)) | 0;
            });

        }


        /**
         * Get an array describing the duration each column should animation for.
         */
        function getTransitionDurations(_now, _was) {

            var _digitsNow = getDigits(_now);
            var _digitsWas = _was ? getDigits(_was) : _digitsNow;

            var _accumulated = DURATION_BASE;
            var _durations = new Array(digitColumns.length);

            for (var i = digitColumns.length - 1; i >= 0; i--) {

                if (_accumulated > 0 || (_digitsNow[i] | 0) !== (_digitsWas[i] | 0)) {
                    _accumulated += DURATION_PER_DIGIT;
                }

                _durations[i] = _accumulated;

            }

            return _durations;

        }


        /**
         * Set the value.
         */
        function setValue(_value, _instant) {

            _value = _value | 0;

            if (_value === currentValue) {
                return;
            }

            addColumns(_value, _instant);
            updateDigitVisibility(_value);

            var _offsets = getDigitOffsets(_value);

            // Animated transition
            if (_instant !== true) {
                tweener = tweener.tweenTo(
                    _offsets,
                    getTransitionDurations(_value, currentValue)
                );
            }

            // Instant transition
            else {
                tweener = tweener.resetTo(_offsets);
                updateAnimationTransforms(_offsets);
            }

            currentValue = _value;

        }


        /**
         * Update the odometer value.
         */
        function updateValue(_instant) {

            setValue(
                $value.text() | 0,
                _instant
            );

        }


        /**
         * Update the animation transforms.
         */
        function updateAnimationTransforms(_offsetsNow, _offsetsWas) {

            digitColumns.forEach(function($digit, i) {

                var _offset = _offsetsNow[i];
                var _delta = (_offsetsWas) ?
                    Math.abs(_offset - _offsetsWas[i]) :
                    0;

                var _translate = (_offset % 10) / 11 * -100;

                $digit.find('i').css('transform', 'translateY(' + _translate + '%)');
                $digit.find('b').css('opacity', Math.max(0, Math.min(_delta * BLUR_THRESHOLD, 1)));

            });

        }


        /**
         * Update the visibility of digit columns.
         */
        function updateDigitVisibility(_value) {

            _value = _value | 0;

            for (var i = 0, ix = digitColumns.length; i < ix; i++) {

                var isHidden = ((_value / Math.pow(10, i)) | 0) === 0;

                digitColumns[i].toggleClass('is-hidden', isHidden);

                if ((i % 3) >> 0 === 0) {
                    var si = (Math.floor(i / 3) - 1) | 0;
                    if (si > -1) {
                        separatorColumns[si].toggleClass('is-hidden', isHidden);
                    }
                }

            }

        }


        /**
         * Main loop tick.
         */
        function tick() {

            if (!tweener.isActive()) {
                return;
            }

            var _offsetsWas = tweener.getTweenedValues();

            tweener.tick();

            var _offsetsNow = tweener.getTweenedValues();

            updateAnimationTransforms(_offsetsNow, tweener.isActive() ? _offsetsWas : _offsetsNow);

            if (!tweener.isActive()) {
                $element.trigger('odometerfinish');
            }

        }


        // Bind event listeners
        $element
            .addClass('odometer')
            .on('change', updateValue)
        ;

        // Set the initial value
        updateValue(true);

        // Start main loop
        (function loop() {
            requestAnimationFrame(loop);
            tick();
        }());

    };

}(jQuery));
